module.exports = __webpack_public_path__ + "img/Slovakia_GP3 - Digital Coalition.3856995b.png";